import { render, staticRenderFns } from "./StockBalance.vue?vue&type=template&id=07ad7850&"
import script from "./StockBalance.vue?vue&type=script&lang=ts&"
export * from "./StockBalance.vue?vue&type=script&lang=ts&"
import style0 from "./StockBalance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports